export class Base64Helper {
  public static toBase64(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }

  public static fromBase64(b64: string): string {
    return decodeURIComponent(escape(window.atob(b64)));
  }
}
